module.exports = __webpack_public_path__ + "img/au.9a095a09.svg";